var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 56,
    viewBox: "0 0 28 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50008 17.417C4.59008 17.417 1.41675 20.5903 1.41675 24.5003C1.41675 28.4103 4.59008 31.5837 8.50008 31.5837C12.4101 31.5837 15.5834 28.4103 15.5834 24.5003C15.5834 20.5903 12.4101 17.417 8.50008 17.417ZM9.20841 28.042H7.79175V26.6253H9.20841V28.042ZM9.20841 25.2087H7.79175V20.9587H9.20841V25.2087Z",
    fill: "#DE1135"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12062_35112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5056 42.5895H27.1723L19.8389 29.9229L12.5056 42.5895ZM20.5056 40.5895H19.1723V39.2562H20.5056V40.5895ZM20.5056 37.9229H19.1723V35.2562H20.5056V37.9229Z",
    fill: "#E6A000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12062_35112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11.8389 28.2559)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertGroup);
export default __webpack_public_path__ + "static/media/alertGroup.05ce69862ce0297c15bc1cc01db646f4.svg";
export { ForwardRef as ReactComponent };